module.exports = __webpack_public_path__ + "static/img/12.08b32aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/12.png
// module id = wejc
// module chunks = 0